var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      _c(
        "el-form",
        {
          ref: "clientForm",
          staticClass: "form-container",
          attrs: {
            model: _vm.clientForm,
            rules: _vm.rules,
            autocomplete: "on",
            "label-position": "left",
            size: "mini",
          },
        },
        [
          _c(
            "sticky",
            {
              attrs: {
                "z-index": 10,
                "class-name": "sub-navbar",
                title: _vm.getTitle,
              },
            },
            [
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  staticStyle: { "margin-left": "10px" },
                  attrs: { type: "success" },
                  on: { click: _vm.submitForm },
                },
                [_vm._v(" Save ")]
              ),
              _c(
                "el-button",
                {
                  directives: [
                    {
                      name: "loading",
                      rawName: "v-loading",
                      value: _vm.loading,
                      expression: "loading",
                    },
                  ],
                  attrs: { type: "warning" },
                  on: { click: _vm.cancelForm },
                },
                [_vm._v(" Cancel ")]
              ),
            ],
            1
          ),
          _c(
            "div",
            { staticClass: "ca-cards" },
            [
              _c(
                "el-row",
                { staticStyle: { width: "100%" } },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("ClientInformation", {
                        staticClass: "ca-card",
                        attrs: { isEdit: _vm.isEdit },
                        model: {
                          value: _vm.clientForm,
                          callback: function ($$v) {
                            _vm.clientForm = $$v
                          },
                          expression: "clientForm",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
              _c(
                "el-row",
                {
                  directives: [
                    {
                      name: "show",
                      rawName: "v-show",
                      value: _vm.clientForm.clientId !== 0,
                      expression: "clientForm.clientId !== 0",
                    },
                  ],
                  staticStyle: { width: "100%" },
                },
                [
                  _c(
                    "el-col",
                    { attrs: { span: 24 } },
                    [
                      _c("ProductsTable", {
                        staticClass: "ca-card",
                        attrs: {
                          list: _vm.productList,
                          listLoading: _vm.productListLoading,
                        },
                        on: {
                          add: _vm.handleAddProduct,
                          edit: _vm.handleEditProduct,
                          delete: _vm.handleDeleteProduct,
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
      _c(
        "el-dialog",
        {
          attrs: {
            title: "Client Product for " + _vm.clientForm.name,
            visible: _vm.productEditVisible,
            width: "75%",
          },
          on: {
            "update:visible": function ($event) {
              _vm.productEditVisible = $event
            },
          },
        },
        [
          _c("ProductEdit", {
            attrs: {
              copyable: "",
              boxed: "",
              value: _vm.productEdit,
              dialogVisible: _vm.productEditVisible,
            },
            on: { close: _vm.handleEditClose },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }